import { useDispatch, useSelector } from "react-redux";
import { setDataToModal, setShowBuyTurnModal, setShowResultModal } from "../../actions/modal";
import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import { BsXCircle } from "react-icons/bs";
import TextField from '@mui/material/TextField';
import MyButton from '../MyButton';
import Countdown from 'react-countdown';
import { BUY_TURN, SHOW_MSISDN, SHOW_OTP, SHOW_PACKAGE, SHOW_SUCCESS } from '../../common/constant';
import { customStyles, headerContainerStyle, iconStyle, titleStyle, textStyle } from '../../common/modalStyle'
import { store } from "../..";
import { buyTurnConfirmUrl, buyTurnUrl } from "../../common/url";
import { restPostApi } from "../../services/httpService";
import { error, httpSuccess, success, waitingForOtp } from "../../common/errorCode";
import { isNotNull } from "../../common/utils";
import { updateAccount } from "../../actions/account";
import { useTranslation } from 'react-i18next';


const MyBuyTurnModal_v2 = ({ isOpenOtp }) => {
    let modalReducer = useSelector((state) => state.ModalReducer);
    const [errorMessage, setErrorMessage] = React.useState("");
    const dataRef = useRef(["", ""]);
    const dispatch = useDispatch();
    const account = useSelector((state) => state.AccountReducer);
    const [step, setStep] = React.useState(modalReducer.dataToModal.action = BUY_TURN ? SHOW_PACKAGE : SHOW_MSISDN);
    const tokenInfo = useSelector((state) => state.SessionReducer);
    const [packBuy, setPackBuy] = React.useState("");
    const [requestId, setRequestId] = React.useState("");
    const [enableResend, setEnableResend] = React.useState(false);
    const [countDownDate, setCountDownDate] = React.useState(Date.now() + 60 * 1000);
    const { t } = useTranslation();


    console.log("modalReducer MyResultModal: " + JSON.stringify(modalReducer));


    function closeModal() {
        setStep(SHOW_PACKAGE);
        store.dispatch(setShowBuyTurnModal(false));
    }

    async function confirmClick() {
        if (step === SHOW_MSISDN) {
            // step 1 => call to get OTP
            let msisdn = account.accountUser.msisdn;
            if (!isNotNull(msisdn)) {
                return;
            }
            let res = await restPostApi(
                buyTurnUrl,
                {
                    "msisdn": msisdn,
                    "packageName": packBuy
                },
                tokenInfo
            );

            console.log("res: " + JSON.stringify(res));

            let message = "";
            let errorCode = error;

            if (res != null) {
                console.log("status: " + res.status);

                if (res.status === httpSuccess) {
                    console.log("errorCode: " + res.data.errorCode);
                    errorCode = res.data.errorCode;
                    if (res.data.errorCode === waitingForOtp) {
                        // get requestId
                        setRequestId(res.data.data.requestId);
                        console.log("requestId: " + res.data.data.requestId);
                        setCountDownDate(Date.now() + 60 * 1000);

                        setStep(SHOW_OTP);
                        return;
                    } else {
                        console.log("message: " + res.data.message);
                        message = res.data.message;
                    }
                } else {
                    console.log("message: " + res.data);
                    message = res.data;
                }
            } else {
                console.log("message: Exception");
                message = "Exception"
            }
            setStep(SHOW_PACKAGE);
            store.dispatch(setDataToModal({
                type: 'result',
                dataToModal: {
                    errorCode: errorCode,
                    message: message
                }
            }));
        } else if (step === SHOW_OTP) {
            let otp = dataRef.current[1].value;
            if (!isNotNull(otp)) {
                return;
            }
            let res = await restPostApi(
                buyTurnConfirmUrl,
                {
                    "msisdn": account.accountUser.msisdn,
                    "packageName": packBuy,
                    "otp": otp,
                    "requestId": requestId
                },
                tokenInfo
            );
            let message = "";
            let errorCode = error;
            console.log("status: " + res.status);
            if (res.status === httpSuccess) {
                console.log("errorCode: " + res.data.errorCode);

                message = res.data.message;
                errorCode = res.data.errorCode;

                if (res.data.errorCode === success) {
                    // update accountUser
                    let accountInfo = {
                        accountUser: res.data.data.accountUser,
                        regInfos: res.data.data.regInfos
                    };
                    dispatch(updateAccount(accountInfo));

                    console.log("message: " + res.data.message);
                } else {
                    console.log("message: " + res.data.message);
                    setErrorMessage(res.data.message);
                    return;
                }
            } else {
                console.log("message: " + res.data);
            }
            setStep(SHOW_PACKAGE);
            store.dispatch(setDataToModal({
                type: 'result',
                dataToModal: {
                    errorCode: errorCode,
                    message: message
                }
            }));
        }
    }

    function choosePackage(packageName) {
        console.log("choose " + packageName);
        setPackBuy(packageName);
        // show msisdn
        setStep(SHOW_MSISDN);
        setErrorMessage("");
        setEnableResend(false);
    }

    async function resendOtpClick() {
        if (enableResend) {
            setEnableResend(false);
            setCountDownDate(Date.now() + 60 * 1000);
            // step 1 => call to get OTP
            let msisdn = account.accountUser.msisdn;
            if (!isNotNull(msisdn)) {
                return;
            }
            let res = await restPostApi(
                buyTurnUrl,
                {
                    "msisdn": msisdn,
                    "packageName": packBuy
                },
                tokenInfo
            );

            console.log("res: " + JSON.stringify(res));

            let message = "";
            let errorCode = error;

            if (res != null) {
                console.log("status: " + res.status);

                if (res.status === httpSuccess) {
                    console.log("errorCode: " + res.data.errorCode);
                    errorCode = res.data.errorCode;
                    if (res.data.errorCode === waitingForOtp) {
                        // get requestId
                        setRequestId(res.data.data.requestId);
                        console.log("requestId: " + res.data.data.requestId);
                        setStep(SHOW_OTP);
                        return;
                    } else {
                        console.log("message: " + res.data.message);
                        message = res.data.message;
                    }
                } else {
                    console.log("message: " + res.data);
                    message = res.data;
                }
            } else {
                console.log("message: Exception");
                message = "Exception"
            }
            setStep(SHOW_PACKAGE);
            store.dispatch(setDataToModal({
                type: 'result',
                dataToModal: {
                    errorCode: errorCode,
                    message: message
                }
            }));
        }
    }

    const renderer = ({ minutes, seconds }) => {
        let min = minutes;
        let sec = seconds;
        if (minutes < 10) {
            min = "0" + minutes;
        }
        if (seconds < 10) {
            sec = "0" + seconds;
        }
        if (seconds == 0 && minutes == 0) {
            console.log("set resend to show");
            setEnableResend(true);
        }
        return <span>{min}:{sec}</span>;
    }
    console.log("STEP: " + step);

    return (

        <div>
            <Modal
                isOpen={isOpenOtp}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Buy Turn Modal"
            >
                <div style={headerContainerStyle}>
                    <div style={iconStyle} onClick={closeModal}>
                        <BsXCircle style={{ height: "2rem", width: "2rem" }} />
                    </div>
                </div>
                {
                    step ==
                        SHOW_PACKAGE ?
                        <div>
                            <div style={titleStyle}>{t("buyMore")}</div>
                            <div style={textStyle}>{t("choosePackage")} </div>
                        </div> : step == SHOW_MSISDN ?
                            <div>
                                <div style={titleStyle}>{t("confirmToBuyMoreTurn").toUpperCase()}</div>
                                <div style={textStyle}>{t("confirmMsisdn")}</div>
                            </div> :
                            step == SHOW_OTP ? <div>
                                <div style={titleStyle}>{t("confirmToBuyMoreTurn").toUpperCase()}</div>
                                <div style={isNotNull(errorMessage) && errorMessage != "" ? {
                                    color: "red",
                                    textAlign: "center",
                                    marginTop: "18px"
                                } : textStyle}>
                                    {isNotNull(errorMessage) && errorMessage != "" ?
                                        errorMessage :
                                        t("otpSent")}</div>
                            </div> :
                                <div style={{
                                    color: "black",
                                    textAlign: "center",
                                    marginTop: "20px",
                                    fontWeight: "600"
                                }}>
                                    Result of transaction
                                </div>
                }
                {step == SHOW_PACKAGE ?
                    <div>
                        <div className='row card-container'>
                            <div className='col-6'>
                                <div className='item' onClick={() => choosePackage('CHARGE100')}>
                                    <h4>
                                        {t("100Kip1Turn")} / 
                                    </h4>
                                    <h4>
                                        1 {t("turn")}
                                    </h4>
                                </div>
                            </div>
                            <div className='col-6'>
                                <div className='item' onClick={() => choosePackage('CHARGE200')}>
                                    <h4>
                                        {t("200Kip5Turns")} /
                                    </h4>
                                    <h4>
                                        5 {t("turns")}
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <div style={{ marginTop: "20px" }}>
                        </div>
                    </div>
                    :
                    <div>
                        {/* <div style={{
                            color: step == SHOW_SUCCESS ? "green" : "red",
                            textAlign: "center",
                            marginTop: "20px"
                        }}>
                            {errorMessage}
                        </div> */}
                        <div style={{ textAlign: "center", marginTop: "20px" }}>
                            {
                                step === SHOW_MSISDN ?
                                    <TextField id="standard-basic-msisdn"
                                        key={"msisdn"}
                                        inputProps={{ min: 0, style: { textAlign: 'center' } }}
                                        inputRef={(element) => { dataRef.current[0] = element }}
                                        label={account.accountUser.msisdn == "" ? "Phone number" : ""}
                                        variant="standard"
                                        style={{ textAlign: "center", width: "70%" }}
                                        // value={dataInit}
                                        defaultValue={account.accountUser.msisdn}
                                    /> :
                                    step === SHOW_OTP ?
                                        <TextField id="standard-basic-otp"
                                            key={"otp"}
                                            inputProps={{ min: 0, style: { textAlign: 'center' } }}
                                            inputRef={(element) => { dataRef.current[1] = element }}
                                            label="OTP" variant="standard"
                                            style={{ textAlign: "center", width: "70%" }}
                                            defaultValue={""}
                                        />
                                        :
                                        <div></div>
                            }
                        </div>
                        {
                            step === SHOW_OTP ?
                                <div className='row' style={{ width: "70%", margin: "auto", fontSize: "13px", fontWeight: 600, marginTop: "10px" }}>
                                    <div className='col-6' style={{ paddingLeft: "0px" }}>
                                        {t("remain")}: <Countdown date={countDownDate} renderer={renderer} />
                                    </div>
                                    <div className={enableResend ? 'col-6' : 'col-6 disabled-click'}
                                        style={{ textAlign: "end", paddingRight: "0px", textDecoration: "underline" }}
                                        disabled={enableResend}
                                        onClick={resendOtpClick}>
                                        {t("resendOtp")}
                                    </div>
                                </div> :
                                <div></div>}
                        <div style={{ marginTop: "20px" }}>
                        </div>
                        <MyButton onClickButton={confirmClick} />
                        <div style={{ marginTop: "20px" }}>
                        </div>
                    </div>
                }

            </Modal>
        </div>
    );
}

export default MyBuyTurnModal_v2;